import type { ReactNode } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { links } from '@eis/core';
import { PageHeader, PageLayout } from '@eis/patterns';
import { LeadFormDialog } from './LeadFormDialog';

/**
 * `/insurance/leads/new` (SDD-013 §8.1.5): the standalone create dialog on its own route, so a
 * link to "new lead" is a link and the dialog survives a reload. Saving navigates to the lead's
 * detail — the next action is always a transition, never the list (SDD-002 §5).
 */
export function LeadCreatePage(): ReactNode {
  const { t } = useTranslation('insurance');
  const navigate = useNavigate();
  return (
    <PageLayout
      header={
        <PageHeader
          title={t('leads.create.title')}
          breadcrumbs={[{ label: t('leads.title'), to: links.insurance.leads() }, { label: t('leads.create.title') }]}
        />
      }
    >
      <LeadFormDialog
        mode={{ kind: 'create', parentPolicyCode: '' }}
        open
        onClose={() => {
          void navigate({ href: links.insurance.leads() });
        }}
        onSaved={(code) => {
          void navigate({ href: links.insurance.lead(code) });
        }}
      />
    </PageLayout>
  );
}
